import { Box, Button, Stack, Typography } from '@mui/material';
import { EditState } from '../types';

export interface CropControlsProps {
  currentEditState: EditState;
  isCropping: boolean;
  isSquareCropMode: boolean;
  isFourThreeCropMode: boolean;
  applyCrop: () => void;
  startManualCrop: () => void;
  startSquareCrop: () => void;
  applySquareCrop: () => void;
  cancelSquareCrop: () => void;
  startFourThreeCrop: () => void;
  applyFourThreeModeCrop: () => void;
  cancelFourThreeCrop: () => void;
  cancelManualCrop: () => void;
}

export const CropControls = ({
  currentEditState: _currentEditState,
  isCropping,
  isSquareCropMode,
  isFourThreeCropMode,
  applyCrop,
  startManualCrop,
  startSquareCrop,
  applySquareCrop,
  cancelSquareCrop,
  startFourThreeCrop,
  applyFourThreeModeCrop,
  cancelFourThreeCrop,
  cancelManualCrop,
}: CropControlsProps) => {
  return (
    <Box>
      <Typography
        color="white"
        sx={{ display: { xs: 'none', md: 'block' }, my: 1 }}
      >
        Crop
      </Typography>
      <Stack direction="row" spacing={2} mb={2} alignItems="center">
        {!isCropping ? (
          <Button
            onClick={startManualCrop}
            aria-label="Start manual crop"
            sx={{
              border: '2px dotted',
              borderColor: '#fff',
              color: 'white',
            }}
          >
            Manual Crop
          </Button>
        ) : (
          <Stack direction="row" spacing={1}>
            <Button
              onClick={applyCrop}
              variant="contained"
              sx={{
                color: 'white',
                backgroundColor: 'green',
                minWidth: 32,
              }}
            >
              ✓
            </Button>
            <Button
              onClick={cancelManualCrop}
              variant="outlined"
              sx={{
                color: 'white',
                borderColor: 'white',
                minWidth: 32,
                '&:hover': {
                  color: 'buttons.crop.textColor',
                },
              }}
            >
              ✕
            </Button>
          </Stack>
        )}
        {!isSquareCropMode ? (
          <Button
            onClick={startSquareCrop}
            variant="outlined"
            sx={{
              color: 'white',
              borderColor: 'white',
              minWidth: 32,
              '&:hover': {
                color: 'buttons.crop.textColor',
              },
            }}
          >
            1:1
          </Button>
        ) : (
          <Stack direction="row" spacing={1}>
            <Button
              onClick={applySquareCrop}
              variant="contained"
              sx={{
                color: 'white',
                backgroundColor: 'green',
                minWidth: 32,
              }}
            >
              ✓
            </Button>
            <Button
              onClick={cancelSquareCrop}
              variant="outlined"
              sx={{
                color: 'white',
                borderColor: 'white',
                minWidth: 32,
                '&:hover': {
                  color: 'buttons.crop.textColor',
                },
              }}
            >
              ✕
            </Button>
          </Stack>
        )}
        {!isFourThreeCropMode ? (
          <Button
            onClick={startFourThreeCrop}
            variant="outlined"
            sx={{
              color: 'white',
              borderColor: 'white',
              minWidth: 32,
              '&:hover': {
                color: 'buttons.crop.textColor',
              },
            }}
          >
            4:3
          </Button>
        ) : (
          <Stack direction="row" spacing={1}>
            <Button
              onClick={applyFourThreeModeCrop}
              variant="contained"
              sx={{
                color: 'white',
                backgroundColor: 'green',
                minWidth: 32,
              }}
            >
              ✓
            </Button>
            <Button
              onClick={cancelFourThreeCrop}
              variant="outlined"
              sx={{
                color: 'white',
                borderColor: 'white',
                minWidth: 32,
                '&:hover': {
                  color: 'buttons.crop.textColor',
                },
              }}
            >
              ✕
            </Button>
          </Stack>
        )}
      </Stack>
    </Box>
  );
};
